import KlaviyoTableReport from './KlaviyoTableReport';

const KlaviyoSegmentsReport = (props) => (
    <KlaviyoTableReport {...props} table="klaviyo_segments" />
);

export default KlaviyoSegmentsReport;
